import { IconDashboardGauge2 } from '@taki/ui';
import type { ViewType } from '@taki/ui';

/**
 * LE DESCRIPTEUR de la vue custom `ui-lab.jauge` : sa carte d'identite, cote a
 * cote avec son chargeur paresseux. Meme forme que les cinq descripteurs du
 * core (`@taki/ui/views/core`), aucun privilege en moins ni en plus.
 *
 * Il est importe EXPLICITEMENT par l'ecran (`types: [...]`) : une vue ne
 * s'auto-enregistre jamais, sinon le build la supprimerait.
 *
 * Deux champs portent tout le reste :
 * - `extraRoles: ['avancement']` : le role propre a cette vue. Le core ne le
 *   connait pas, il le laisse passer dans `row.extra`.
 * - `requires: ['title', 'avancement']` : sans ce role au binding, l'entree du
 *   selecteur est GRISEE avec sa raison au survol, jamais absente.
 *
 * `demand: 'window'` et `scroll: 'zone'` sont declares honnetement des
 * maintenant, meme si le lot 1 charge tout cote client : c'est ce qui evitera
 * de rouvrir la vue le jour ou le SDK paginera.
 *
 * Le fichier separe du composant n'est pas de la coquetterie : c'est ce qui
 * rend `load()` reellement paresseux (le descripteur est charge avec l'ecran,
 * le rendu seulement quand la vue est choisie).
 */
export const jauge: ViewType = {
  id: 'ui-lab.jauge',
  label: 'Jauge',
  // Icone du registre EXISTANT de @taki/ui : jamais de SVG maison.
  icon: <IconDashboardGauge2 size={15} />,
  level: 'collection',
  requires: ['title', 'avancement'],
  extraRoles: ['avancement'],
  demand: 'window',
  scroll: 'zone',
  load: () => import('./JaugeView.js'),
};

export default jauge;
